<template>
    <div>
        <div class="about-banner">
            <img src="../../static/img/culture.png" />
            <div class="about-banner-word">
                <span>企业文化 Corporate Culture</span>
                <img src="../../static/img/fb.png" @click="changeAboutNav" />
            </div>
        </div>
        <!-- 导航 -->
        <div class="about-nav-bg" v-if="isShowNav"></div>
        <div class="about-nav" v-if="isShowNav">
            <div class="top-nv">
                <span>企业文化</span>
                <img src="../../static/img/close.png" @click="closeAboutNav" />
            </div>
            <div class="about-nv-content">
                <ul>
                    <li @click="toAbout(index)" v-for="(item,index) in menu_active" :key="index">
                        <a>{{item.title}}</a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 导航 结束 -->
        
        <!-- 发展理念 start -->
        <div class="tab-card" style="display:none;">
            <div class="about-title">
                <span class="fn32">发展理念</span>
            </div>
            <div class="develop-img-box">
                <img src="../../static/img/qywh.png" /><img src="../../static/img/cxfw.png" style="width:41.9%;margin-left:.4rem;" /><img src="../../static/img/cxzy.png" style="width:3.14rem;" /><img style="margin-left:.25rem;" src="../../static/img/qywh.png" />
            </div>    
        </div>
        <!-- 发展理念 start -->

        <!-- logo解读 start -->
        <div class="tab-card" style="display:none;">
            <div class="about-title">
                <span class="fn32">名称解读</span>
            </div>
            <div class="qiye-logo">
                    <img src="../../static/img/logo2.png" />
                    企业LOGO：　标识采取象征传统文化、古建特色的红色为标准色，由红色图案搭配黑色字体的汉语简称“德源兴业”及拼音缩写构成。图案包含汉字“众”，象征公司以服务群众、服务社会为根本宗旨，以增进民生福祉、开创美好生活为企业使命；三人成众，象征企业团队建设、团队管理，展现团结协作、开放包容、携手共进的人文情怀；“众”字形似山峰，展现德源人积极向上、开拓创新、勇攀高峰的精神追求；“众”字又形似屋脊，象征公司管房职能和资源，传承古建修缮技艺，保护古都传统风貌，展现公司房管行业的悠久历史和文化特色；图案整体外角圆、内角方，“外圆内方”象征投资管理源源不断创造业绩、创造价值，昭示着蒸蒸日上的未来。
            </div>
        </div>
        <!-- logo解读 start -->

        <!-- 名称解读 start -->
        <div class="tab-card" style="display:none;">
            <div class="about-title">
                <span class="fn32">logo解读</span>
            </div>
            <div class="name-img-box">
                <img src="../../static/img/123_03.png" />
            </div>        
        </div>
        <!-- 名称解读 start -->

        <!-- 董事长致辞 -->
        <div class="tab-card">
            <div class="about-title">
                <span class="fn32">董事长致辞</span>
            </div>
            <div class="qiye-logo">
                <div class="zhici-content" v-html="speech">
                        董事长致辞董事长致辞董事长致辞
                </div>
                <div class="zhici-name">董事长致辞</div>
            </div>
            
        </div>
        <!-- 董事长致辞 end -->

    </div>
</template>

<script>
export default {
    data(){
        return{
            isShowNav:false,
            speech:'',
            menu_active: [
                {
                    title: '发展理念',
                    link: '',
                    isActive: true,
                },
                {
                    title: '名称解读',
                    link: '',
                    isActive: false,
                },
                {
                    title: 'LOGO解读',
                    link: '',
                    isActive: false,
                },
                {
                    title: '董事长致辞',
                    link: '',
                    isActive: false,
                },
            ],
            
        }
    },
    methods:{
        changeAboutNav:function(){
            this.isShowNav=true;
        },
        closeAboutNav:function(){
            this.isShowNav=false;
        },
        menuChange: function(tabIndex){
            var that = this;
            var tabCardCollection = document.querySelectorAll(".tab-card"),
            len = tabCardCollection.length;
            for(var i = 0; i < len; i++) {
                tabCardCollection[i].style.display = "none";
                that.menu_active[i].isActive = false;
            }
            that.menu_active[tabIndex].isActive = true;
            tabCardCollection[tabIndex].style.display = "block";
        },
        toAbout:function(index){
            var that=this;
            var tabCardCollection = document.querySelectorAll(".tab-card"),
                    len = tabCardCollection.length;
                for (var i = 0; i < len; i++) {
                    tabCardCollection[i].style.display = "none";
                }
                tabCardCollection[index].style.display = "block";
                that.isShowNav = false;
        },
        getData: function(){
            var that = this;
            //领导人致辞
            that.$http.post(that.baseUrl+that.config.company).then(function(ev){
                if(ev.data.code == 100){
                    that.speech = ev.data.data.speech;
                }
            }).catch(function(error){
                console.log(error);
            })
        }
    },
     mounted(){
        this.baseUrl = window.baseUrl;
        this.config = window.config;
        this.getData();
    }
    
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Culture.vue